/**
 * The marker a room's results files put in the card column to mean "nobody has claimed this place"
 * (ADR 0013, V3), as the template editor handles it. The server is the control — it refuses a marker
 * on any other template and a marker equal to a card the room holds; this decides what the screen
 * offers and sends.
 */

/** Only a CSV template that imports results reads a marker, so only there is it offered. */
export function acceptsMarker(template: { kind: string; purpose: string }): boolean {
  return template.kind === 'csv' && template.purpose === 'import_tournament_results';
}

/**
 * What a typed marker is saved as: trimmed, and blank as none — which clears a stored one, since the
 * content is saved whole. A marker of spaces would be one no file ever matches.
 */
export function markerForSave(typed: string): string | null {
  const trimmed = typed.trim();
  return trimmed === '' ? null : trimmed;
}

/** Whether the typed marker differs from the stored one, by what would actually be saved. */
export function markerChanged(typed: string, stored: string | null): boolean {
  return markerForSave(typed) !== (stored ?? null);
}
